import React from 'react';
import isNil from 'lodash/isNil';
import ManagerCoachingPageContainer from 'components/coaching/landing-pages/ManagerCoachingPageContainer';
import CoachingPageContainer from 'components/coaching/CoachingPageContainer';
import {loadUpcomingReviewData} from 'components/dashboard/UpcomingCoachingAgenda';
import {getQueryParam, getStringQueryParam} from 'utils/getQueryParam';

export class CoachCoachingPlansWidgetContainer extends React.Component {
  render() {
    return <CoachingPlansWidgetContainer {...this.props} forCoach suppressToggle />;
  }
}

/**
 * This class is a simple wrapper around ManagerCoachingPageContainer to tell it
 * to use a specific child (CoachingPlansWidget) rather than its default one,
 * which shows a fair bit more than ours.
 */
export default class CoachingPlansWidgetContainer extends React.Component {
  render() {
    const planId = getQueryParam(this.props.location, 'planId');
    if (isNil(planId)) {
      return (
        <ManagerCoachingPageContainer
          {...this.props}
          usePropsManagerId
          suppressToggle={this.props.suppressToggle}
        />
      );
    } else {
      return (
        <CoachingPageContainer
          {...this.props}
          repId={getQueryParam(this.props.location, 'repId')}
          planId={parseInt(getStringQueryParam(this.props.location, 'planId'), 10)}
          reviewId={parseInt(getStringQueryParam(this.props.location, 'reviewId'), 10)}
          refreshUpcomingReviews={
            this.props.refreshUpcomingReviews ||
            (() => loadUpcomingReviewData(this.props.managerId, this.props.coachId))
          }
        />
      );
    }
  }
}
